import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Slider from "@mui/material/Slider";
import MuiInput from "@mui/material/Input";
import ConfigData from "../config/config.json";
import { GlobalMessageContext } from "../app/App";

const webserver = ConfigData.WEBSERVER;

const Input = styled(MuiInput)`
  width: 42px;
`;

export default function InputSlider() {
  const [value, setValue] = React.useState(-2);
  const [text, setText] = React.useState("");
  const [commitedValue, setCommitedValue] = React.useState();
  const { setGlobalMessage } = React.useContext(GlobalMessageContext);

  React.useEffect(() => {
    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/settings/getAll",
      { method: "GET", credentials: "include" }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Error: " + response.status);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => setValue(data[0].validityTime))
      .catch((error) => {});
  }, []);

  React.useEffect(() => {
    const changeText = () => {
      if (value === -1) setText("unbegrenzt");
      else if (value === 1) setText("Jahr");
      else setText("Jahre");
    };
    changeText();
  }, [value]);

  React.useEffect(() => {
    if (value !== -2) {
      updateValidityTime(1, value);
    }
  }, [commitedValue]);

  const handleSliderCommit = (event, newValue) => {
    setValue(newValue);
    setCommitedValue(newValue);
  };

  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleInputChange = (event) => {
    setValue(event.target.value === "" ? "" : Number(event.target.value));
  };

  const handleBlur = (event, newValue) => {
    if (value < -1) {
      setValue(-1);
      setCommitedValue(-1);
    } else if (value > 30) {
      setValue(30);
      setCommitedValue(30);
    } else {
      setCommitedValue(value);
    }
  };

  const updateValidityTime = (id, validityTime) => {
    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/settings/setValidityTime/" +
        id,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: validityTime,
      }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Error: " + response.status);
        }
        return response;
      })
      .then(() => {
        setGlobalMessage({
          globalMessage: "Änderung erfolgreich",
          severity: "success",
        });
      })
      .catch((error) => {
        setGlobalMessage({
          globalMessage: "Vorgang fehlgeschlagen",
          severity: "error",
        });
      });
  };

  return (
    <Box sx={{ width: 350 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={6}>
          <Slider
            min={-1}
            max={30}
            value={value}
            onChangeCommitted={handleSliderCommit}
            onChange={handleSliderChange}
            aria-labelledby="input-slider"
          />
        </Grid>
        <Grid item>
          <Input
            value={value}
            size="small"
            onChange={handleInputChange}
            onBlur={handleBlur}
            inputProps={{
              step: 1,
              min: -1,
              max: 30,
              type: "number",
              "aria-labelledby": "input-slider",
            }}
          />
        </Grid>
        <Grid item>
          <Typography id="identifier" gutterBottom>
            {text}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
